// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jw-0";
export var buttonContainer = "_jw-3";
export var cancelButton = "_jw-4";
export var headerSection = "_jw-6";
export var headerTitle = "_jw-9";
export var messageSideLeft = "_jw-1";
export var messageSideRight = "_jw-2";
export var orderNumberContainer = "_jw-7";
export var orderNumberLabel = "_jw-8";
export var submitButton = "_jw-5";